export default {
  home: {
    title: 'Move anywhere. anytime.',
    subTitle: 'with Moovex mobility streaming platform',
  }
};